export default __webpack_public_path__ + "static/Metal_Dinosaur_Gateway-b7a3671564e840cb62ec584dbeea54fc.png";